<template>
  <div class="modal" v-bind:class="{ 'is-active': imageModalView }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <TitleEnUs v-if="lang === 'en-US'" />
        <TitleJa v-else-if="lang === 'ja'" />
        <button
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body">
        <ContentEnUs v-if="lang === 'en-US'" :company="company" />
        <ContentJa v-else-if="lang === 'ja'" :company="company" />
      </section>
      <footer class="modal-card-foot">
        <button @click="$emit('close')" class="button">Close</button>
      </footer>
    </div>
  </div>
</template>
<script>
import TitleJa from "@/components/projects/license/title.ja";
import TitleEnUs from "@/components/projects/license/title.en-US";
import ContentJa from "@/components/projects/license/content.ja";
import ContentEnUs from "@/components/projects/license/content.en-US";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

export default {
  components: {
    TitleJa,
    TitleEnUs,
    ContentJa,
    ContentEnUs,
  },
  props: {
    company: {
      type: String,
      require: true,
    },
    imageModalView: {
      type: Boolean,
      require: true,
    },
  },
  setup() {
    const { locale } = useI18n();

    return {
      lang: computed(() => {
        return locale.value;
      }),
    };
  },
};
</script>
